import { useSelector } from "react-redux";
import { Loaders } from "../common/store/loaders/loaders.enum";
import { useDispatch } from "react-redux";
import { LoadersMethods } from "../common/store/loaders/loaders.methods";
import { createSelector } from "@reduxjs/toolkit";

interface UseLoadersProps {
  loaders: Loaders | Loaders[];
}

const createLoadersSelector = (loaders: Loaders[]) =>
  createSelector(
    [(state: any) => state],
    (state) => loaders.map((loader) => state?.[loader])
  );

const useLoaders = ({ loaders = [] }: UseLoadersProps) => {
  const dispatch = useDispatch();
  const loadersArr = Array.isArray(loaders) ? loaders : [loaders];
  const selectLoaders = createLoadersSelector(loadersArr);
  const storeLoaders = useSelector(selectLoaders);

  const setIsLoading = (isLoading: boolean) => {
    const entities = loadersArr.reduce((acc, loader) => {
      acc[loader] = isLoading;
      return acc;
    }, {} as any);
    dispatch({
      type: LoadersMethods.UpdateLoader,
      payload: { entities },
    })
  }
  
  return {
    isLoading: storeLoaders.some((loader: any) => loader?.isLoading),
    setIsLoading,
  };
};

export default useLoaders;
